import Form from 'src/utils/Form'
import { Cookies } from 'quasar'

const state = {
  menu_items: [],
  menu_loading: false,
  error_500: false,
  lang: 'en-us'
};

const mutations = {
  'SET_MENU_ITEMS'(state, items) {
    state.menu_items = items;
  },
  'SET_MENU_BADGE'(state, badge) {
    let menu_item = state.menu_items.find(item => item.name === badge.name)
    if(! menu_item) return
    menu_item.badge.value = badge.value
    menu_item.badge.color = badge.color
  },
  'SET_MENU_LOADING'(state, arg) {
    state.menu_loading = arg;
  },
  'SET_LANG'(state, arg) {
    state.lang = arg;
  },
  'SET_ERROR_500'(state, arg) {
    state.error_500 = arg;
  }
};

const actions = {
  set_menu_items: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit('SET_MENU_LOADING', true);
      new Form().get('menu').then((response) => {
        commit('SET_MENU_ITEMS', response);
        commit('SET_MENU_LOADING', false);
        resolve(response)
      }).catch((error) => {
        commit('SET_MENU_LOADING', false);
        reject(error)
      })
    })
  },
  set_menu_badge: ({commit}, payload) => {
      commit('SET_MENU_BADGE', payload);
  },
  set_lang: ({commit}, payload) => {
    commit('SET_LANG', payload)
    Cookies.set('lang', payload, {
      expires: '365d',
      path: '/'
    })
  },
  set_error_500: ({commit}, payload) => {
    commit('SET_ERROR_500',payload)
  }
};

const getters = {
  menu_major_side_items: state => {
    return state.menu_items.filter(item => item.side === 'major');
  },
  menu_minor_side_items: state => {
    return state.menu_items.filter(item => item.side === 'minor');
  },
  menu_loading: state => {
    return state.menu_loading;
  },
  lang: state => {
    return state.lang
  },
  error_500: state => {
    return state.error_500
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
